import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InlineField } from "../private/InlineField/InlineField.mjs";
import { resolveCheckedGroup } from "./resolveCheckedGroup.mjs";
const Checkbox = forwardRef(
  ({ checked, ...restProps }, ref) => {
    const calculatedChecked = Array.isArray(checked) ? resolveCheckedGroup(checked) : checked;
    return /* @__PURE__ */ jsx(InlineField, { ...restProps, checked: calculatedChecked, type: "checkbox", ref });
  }
);
Checkbox.displayName = "Checkbox";
export {
  Checkbox
};
